import { useState, useEffect } from "react";
import RestoreAndDeleteButton from "./RestoreAndDeleteButton";
import format_date_formal from "../../App/validation/format_date_formal";
import format_time_formal from "../../App/validation/format_time_formal";
import { Checkbox } from "@mui/material";
import LongPress from "../common_trivial/LongPress";
import useLanguage from "../common_hooks/useLanguage";

function RecoveryList({
  content,
  toggle_is_multiple,
  is_multiple,
  is_checked = false,
  push_selected,
  actived_tab,
  set_recovery_of_projects,
  set_recovery_of_layers,
  delete_permanent,
  toggle_modal_restore_confirmation,
}) {
  const { name, trash, isPublic } = content;
  const { updated_at } = trash;
  const [checked, set_checked] = useState(false);
  const { dict, language } = useLanguage();

  useEffect(() => {
    set_checked(is_checked);
  }, [is_checked]);

  const toggle_checkbox = () => {
    set_checked(!is_checked);
    push_selected(content);
  };

  return (
    <LongPress
      delay={800}
      onLongPress={() => {
        toggle_is_multiple();
      }}
      className="recovery_list"
    >
      <div className="flex w_full h_full">
        <div className="margin_x_20 w_full flex justify_between gap_20">
          <section className="center_perfect">
            <label className="title_recovery_card">{name}</label>
          </section>
          <section className="flex gap_40">
            <label className="center_perfect semi_bold">
              {dict["Deleted Date"][language]}: {format_date_formal(updated_at)}{" "}
              {format_time_formal(updated_at)}
            </label>
            <div className="center_perfect">
              <label className="bg_lightGrey rounded padding_x_15 padding_y_5 paddingTop rounded_10 h_20">
                {isPublic ? "Public" : "Private"}
              </label>
            </div>
          </section>
          <section className="center_perfect">
            {is_multiple ? (
              <Checkbox
                onChange={toggle_checkbox}
                checked={checked}
                style={{ margin: 0, padding: 0 }}
              />
            ) : (
              <RestoreAndDeleteButton
                actived_tab={actived_tab}
                content={content}
                set_recovery_of_projects={set_recovery_of_projects}
                set_recovery_of_layers={set_recovery_of_layers}
                delete_permanent={delete_permanent}
                toggle_modal_restore_confirmation={
                  toggle_modal_restore_confirmation
                }
              />
            )}
          </section>
        </div>
      </div>
    </LongPress>
  );
}

export default RecoveryList;
